import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type ReferralData = {
  referralCode: string;
  referralsCount: number;
};

export type RecordReferralRequest = {
  referralCode: string;
};

const ReferralsAPI = {
  get: () => APIClient(CONFIG.API_ENDPOINT).get<ReferralData>(`/v1/referrals`),
  record: (referralCode: string) => APIClient(CONFIG.API_ENDPOINT).post<RecordReferralRequest, void>(`/v1/referrals`, { referralCode }),
};

export default ReferralsAPI;

